// import Cookie from 'js-cookie'
import utils from '../assets/js/utils'

export default {
  state: {
    isCollapse: false,
    currentMenu: null,
    menu: [],
    tabsList: [
      {
        path: '/',
        name: 'home',
        label: '首页',
        icon: 'home'
      }
    ]
  },
  mutations: {
    setMenu(state, val) {
      state.menu = val
      // Cookie.set('menu', JSON.stringify(val))
      utils.setMenuCookie(val)
      console.log(val, 'vuex')
    },
    clearMenu(state) {
      state.menu = []
      // Cookie.remove('menu')
      utils.clearMenuCookie()
    },
    addMenu(state, router) {
      let menu = utils.getMenuCookie()
      if (!menu) {
        return
      }
      // console.log(menu, 'menu................')
      state.menu = menu
      let currentMenu = [
        {
          path: '/',
          component: () => import(`@/views/Main`),
          children: []
        }
      ]
      console.log(menu, 'menu....................2')
      menu.forEach(item => {
        if (item.children) {
          item.children = item.children.map(item => {
            item.component = () => import(`@/views/${item.url}`)
            return item
          })
          currentMenu[0].children.push(...item.children)
        } else {
          item.component = () => import(`@/views/${item.url}`)
          currentMenu[0].children.push(item)
        }
      })
      console.log(currentMenu, 'cur')
      router.addRoutes(currentMenu)
    },
    selectMenu(state, val) {
      if (val.name !== 'home') {
        state.currentMenu = val
        let result = state.tabsList.findIndex(item => item.name === val.name)
        result === -1 ? state.tabsList.push(val) : ''
        // Cookie.set('tagList', JSON.stringify(state.tabsList))
        utils.setTagListCookie(state.tabsList)
      } else {
        state.currentMenu = null
      }
      // val.name === 'home' ? (state.currentMenu = null) : (state.currentMenu = val)
    },
    getMenu(state) {
      let tagList = utils.getTagListCookie()
      if (tagList) {
        console.log('haha')
        // let tagList = JSON.parse(tagList)
        state.tabsList = tagList
      }
    },
    closeTab(state, val) {
      let result = state.tabsList.findIndex(item => item.name === val.name)
      state.tabsList.splice(result, 1)
    },
    collapseMenu(state) {
      state.isCollapse = !state.isCollapse
    }
  },
  actions: {}
}
